// extracted by mini-css-extract-plugin
export default {"allergiesContainer":"Allergies_allergiesContainer__HPOVm"};